interface Props {
  onConnect: () => void;
  isConnecting: boolean;
  error: string | null;
}

export function ConnectPrompt({ onConnect, isConnecting, error }: Props) {
  return (
    <div className="flex items-center justify-center min-h-[50vh] sm:min-h-[60vh] px-4">
      <div className="text-center max-w-md w-full">
        {/* Logo */}
        <img
          src="/logo.png"
          alt="Ternoa"
          className="w-24 h-24 sm:w-32 sm:h-32 mx-auto mb-6 sm:mb-8 rounded-ternoa object-contain"
        />

        <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mb-3">
          Ternoa Shield
        </h2>
        <p className="text-sm sm:text-base text-gray-400 mb-6 sm:mb-8 leading-relaxed">
          Connect your wallet to view balances, earn Shield points, and claim $KAT airdrops.
        </p>

        <button onClick={onConnect} className="btn-primary w-full" disabled={isConnecting}>
          {isConnecting ? (
            <span className="flex items-center gap-2">
              <svg className="animate-spin w-4 h-4" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" strokeDasharray="30 70" />
              </svg>
              Connecting...
            </span>
          ) : (
            'Connect Wallet'
          )}
        </button>

        {error && (
          <p className="text-sm text-red-400 mt-4">{error}</p>
        )}

        <p className="text-xs text-muted mt-6">
          Supports MetaMask & Rabby on Ternoa zkEVM
        </p>
      </div>
    </div>
  );
}
